import { Outlet, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import { AuthContext } from "src/context/AuthContext";
import { autoAppyUrl } from "src/config/autoAppyUrls";
import mark from "src/assets/branding/auto-appy-mark-256x256.png";
import "src/stage/wa-stage.css";

function ProtectedRoute() {
  const { auth, loading, beginLogin, authError } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!loading && !auth && !authError)
      beginLogin(`${location.pathname}${location.search}`);
  }, [
    auth,
    authError,
    beginLogin,
    loading,
    location.pathname,
    location.search,
  ]);

  if (authError === "access_denied") {
    return (
      <div
        role="alert"
        className="m-8 rounded-xl border border-red-200 bg-red-50 p-6 text-red-800"
      >
        <p>
          We couldn’t confirm WhatsApp access for this session. Sign in with the
          Auto Appy account invited to your organisation.
        </p>
        <div className="mt-4 flex flex-wrap gap-4">
          <a href="/" className="font-semibold underline">
            Sign in with Auto Appy
          </a>
          <a href={autoAppyUrl("/organisation")} className="underline">
            Check organisation access
          </a>
        </div>
      </div>
    );
  }
  if (loading || !auth)
    return (
      <div className="wa-connecting" role="status">
        <img src={mark} alt="" />
        <span>Opening Auto Appy WhatsApp…</span>
      </div>
    );
  return <Outlet />;
}

export default ProtectedRoute;
